import { render, staticRenderFns } from "./pop-seabed.vue?vue&type=template&id=9f4e2166&scoped=true&"
import script from "./pop-seabed.vue?vue&type=script&lang=js&"
export * from "./pop-seabed.vue?vue&type=script&lang=js&"
import style0 from "./pop-seabed.vue?vue&type=style&index=0&id=9f4e2166&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4e2166",
  null
  
)

export default component.exports